<template>
    <div class="grid justify-items-stretc">
        <div class="flex items-center justify-between pt-8 md:pt-0  px-6">
            <span class="flex items-center ">
                <PostContentIcon class="mr-2"/>
                Post Content
            </span>
            <Arrow/>
        </div>
        <div class="m-6 p-6 pr-8 bg-white rounded-lg flex flex-col">
            <span class=" text-sm font-semibold mb-2">Caption</span>
            <TextareaEmojiPicker v-if="edit == 'edit'" @captionChanged="changeCaption" :disable="posted" :text="post.caption" :placeholder="post.caption"/>
            <p v-else-if="edit != 'edit'" @click="edit='edit'" class=" border-b-2 border-gray-100 pb-8 font-semibold mb-4 text-sm cursor-pointer">{{post.caption}}</p>
            <span class=" text-sm text-payneFire font-semibold">Platforms Posted</span>
            <PlatformRow v-show="!posted" :postId="post.id" v-for="userPage in userPages" v-bind:key="userPage.id" @changePage="changeToggle" :disable="posted"  :social="userPage.provider" :page="userPage" :postingPages="post.pages" :edit="edit" styles="static w-8 h-8" />
            <PlatformRow v-show="posted" :postId="post.id" v-for="postedPages in post.pages" v-bind:key="postedPages.id" @changePage="changeToggle" :disable="posted" :social="postedPages.provider" :page="postedPages" :postingPages="post.pages" :edit="edit" styles="static w-8 h-8" />
        </div>
        <button @click="updateCaption" :disabled="posted" :class="saved ? 'bg-aquamarine text-white border-aquamarine': 'bg-platinumFire text-cosmosHot border-gray-200'" class=" transition-all ease-in rounded-lg px-10 py-3 justify-self-end text-sm  border-2  mr-6">
            <span>Save</span>
        </button>
  </div>
</template>

<script>
import TextareaEmojiPicker from "@/components/scheduler/Common/TextareaEmojiPicker";
import PlatformRow from '@/components/scheduler/Show/PlatformRow';

import PostContentIcon from '@/components/svg/PostContentIcon';

export default {
    name:"PostContent",

    props: {
        edit: {
            type: String,
            required: true
        },
        post: {
            type: Object,
            required: true
        },
        userPages: {
            type: Array,
            required: true
        },
        posted: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            caption: '',
            saved: false
        }
    }, 

    components: {
        PostContentIcon,
        TextareaEmojiPicker,
        PlatformRow
    },

    methods: {
        changeToggle(){
           this.saved=true;
        },
        async updateCaption() {
        this.$emit("updatingPost", true);
        this.saved = false;
        if (this.caption === "") {
            this.$emit("captionChange");
        }
        await this.$inertia.put(
            this.$route("scheduler.posts.update", { postId: this.post.id }),
            { caption: this.caption },
            {
            preserveScroll: true
            }
        );
        this.$emit("loadPosts");
        this.$emit("updatingPost", false);

        },

        changeCaption(caption) {
            this.saved=true;
            this.caption = caption;
        },
    }
}
</script>